import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // 16px базовый размер — не косметика: на iOS поле с текстом мельче
        // 16px заставляет Safari зумить страницу при фокусе, и человек
        // проваливается в увеличенный экран посреди ввода суммы.
        "lp-field flex h-11 w-full px-3.5 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
